export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};

// Values are corresponding with names in package.json
export const InstanceTypes = {
	INSTANCE_BO: 'bo',
	INSTANCE_FO: 'fo',
};
